/* eslint-disable import/prefer-default-export */
import { useUpc } from '@common-vue/media-card-large';
import { toValue } from '@vueuse/core';
import { useProduct } from '@modules/product';
import { useColor } from '@modules/color';
import { useSize } from '@modules/size';
import { swapKV } from '@utils/objects';

/**
 * @param {import('@vueuse/core').MaybeRef<string | number>} upcId
 */
export const useUpcPreselectConsolidated = (upcId) => {
  const { productId } = useProduct();
  const { upcData } = useUpc(productId);
  const { selectedSizeId } = useSize();
  const { selectedColorId } = useColor();
  const swapped = swapKV(upcData.value.upcMap);

  const preselectedUpc = toValue(upcId);

  const traitsKey = swapped[preselectedUpc];
  if (!traitsKey) {
    return;
  }
  const [colorId, sizeId] = traitsKey.toString().split('_');
  if (sizeId !== undefined) {
    selectedSizeId.value = +sizeId;
  }
  // Removed undefined check here because we always get something for colorId from traitsKey if its not falsy
  selectedColorId.value = +colorId;

  // TODO Implement orientation preselection
};
